import { render, staticRenderFns } from "./licitacoes.vue?vue&type=template&id=fed8fe90&scoped=true&"
import script from "./licitacoes.ts?vue&type=script&lang=ts&"
export * from "./licitacoes.ts?vue&type=script&lang=ts&"
import style0 from "./licitacoes.vue?vue&type=style&index=0&id=fed8fe90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed8fe90",
  null
  
)

export default component.exports